import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { customAPIRequest } from '../auth/util/util';
import { loaderActions } from '../actions/loaderActions';
import Loader from './Loader';
import { Grid, Paper } from '@mui/material';
import Header from './Header';
import "./MyCourses.css"
import { moodleAppBaseUrl } from '../auth/util/CustomConstants';
import coursePageBg from "../../assets/courses.png"


function MyCourses() {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [courses, setCourses] = useState([]);
    const [userMoodleID, setUserMoodleID] = useState("");
    const userEmail = localStorage.getItem("email") || null;

    // update this array with the wordpress/other courses you want to display on the page
    const wordpressCourses = [
        {
            id: 1,
            url: "https://www.mysphere.net/courses/computer-science-it/",
            title: "Computer Science & IT",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Computer-Science-IT-300x169.png"
        },
        {
            id: 2,
            url: "https://www.mysphere.net/courses/design-fine-arts/",
            title: "Design & Fine Arts",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Design-Fine-Arts-300x169.png"
        },
        {
            id: 3,
            url: "https://www.mysphere.net/courses/business-management/",
            title: "Business Management",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Business-Management-300x169.png"
        },
        {
            id: 4,
            url: "https://www.mysphere.net/courses/humanities/",
            title: "Humanities",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Humanities-300x169.png"
        },
        {
            id: 5,
            url: "https://www.mysphere.net/courses/engineering-technology/",
            title: "Engineering & Technology",
            image: "https://www.mysphere.net/wp-content/uploads/2022/12/Engineering-Technology.png"
        },
        {
            id: 6,
            url: "https://www.mysphere.net/courses/finance/",
            title: "Finance",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Finance-300x169.png"
        },
        {
            id: 7,
            url: "https://www.mysphere.net/courses/health-fitness/",
            title: "Health & Fitness",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Health-Fitness-300x169.png"
        },
        {
            id: 8,
            url: "https://www.mysphere.net/courses/personal-development/",
            title: "Personal Development",
            image: "https://www.mysphere.net/wp-content/uploads/2021/10/Personal-Development-300x169.png"
        },
        {
            id: 9,
            url: "https://www.mysphere.net/courses/hospitality/",
            title: "Hospitality",
            image: "https://www.mysphere.net/wp-content/uploads/2022/09/Career-page-1640-×-924-px-300x169.jpg"
        },
        {
            id: 10,
            url: "https://www.mysphere.net/coder/",
            title: "Coder",
            image: "https://www.mysphere.net/wp-content/uploads/2024/05/coding-image.png"
        },
        {
            id: 11,
            url: "https://www.mysphere.net/courses/critical-thinking/",
            title: "Critical Thinking",
            image: "https://www.mysphere.net/wp-content/uploads/2023/03/RKM-300x169.jpg"
        },
        {
            id: 12,
            url: "https://www.mysphere.net/tinkering/",
            title: "Tinkering",
            image: "https://www.mysphere.net/wp-content/uploads/2024/05/robotics-1.png"
        },
        {
            id: 13,
            url: "https://www.mysphere.net/diy-stem/",
            title: "DIY STEM",
            image: "https://www.mysphere.net/wp-content/uploads/2024/05/diy-stem-2.png"
        },
    ]

    // fetch courses from moodle
    const fetchCourses = async () => {

        try {
            if (!userEmail) return;
            const response = await customAPIRequest("core_user_get_users_by_field", { "field": "email", "values[0]": userEmail });
            const userId = response?.data?.[0]?.id;

            if (userId) {
                setUserMoodleID(userId);
                const coursesResponse = await customAPIRequest("core_enrol_get_users_courses", { "userid": userId, "returnusercount": 0 });

                if (coursesResponse?.data?.length) {
                    const coursesArray = coursesResponse.data.map(course => ({
                        id: course.id,
                        summary: course.summary,
                        title: course.fullname,
                        progress: Math.round(course.progress),
                        image: course?.overviewfiles?.[0]?.fileurl.replace("/webservice", "") || null,
                    }));
                    setCourses(coursesArray);
                }
            }
        } catch (error) {
            console.error("Error fetching courses: ", error);
        } finally {
            dispatch(loaderActions.stop());
            setLoading(false);
        }
    };

    // function to generate params for the moodle login url
    const paramsGenerator = (objToAct) => {
        return Object.keys(objToAct)
            .map(
                (key) =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(objToAct[key])}`
            )
            .join("&");
    };

    // function to take moodle course
    const takeCourse = async (courseId) => {
        try {
            if (!userEmail) return;
            const moodleLoginUrl = await customAPIRequest(
                "auth_userkey_request_login_url",
                { "user[email]": userEmail }
            );
            if (moodleLoginUrl?.data?.loginurl) {
                const wantsParam = {
                    wantsurl: `${moodleAppBaseUrl}course/view.php?id=${courseId}`,
                };
                const paramsForWantsUrl = paramsGenerator(wantsParam);
                const actionLink = `${moodleLoginUrl.data.loginurl}&${paramsForWantsUrl}`
                window.location.href = actionLink;
            } else {
                return;
            }
        } catch (error) {
            console.log("Error in taking course", error);
        }
    };

    useEffect(() => {
        dispatch(loaderActions.start())
        setLoading(true)
        const init = async () => {
            try {
                await fetchCourses();

            } catch (error) {
                console.log("error func(init) ", error);
            }
        }
        init()
    }, []);

    // updates the title class to add no-animation class if the title fits in the container
    useEffect(() => {
        const titles = document.querySelectorAll('.title');
        titles.forEach((title) => {
            const parent = title.parentElement;
            if (title.getBoundingClientRect().width + 22 <= parent.getBoundingClientRect().width) {
                title.classList.add('no-animation');
            }
        });
    }, [wordpressCourses, courses]);

    return loading ? (
        <Loader />
    ) : (
        <>
            <Header />
            <div className='hero'>
                <div className='hero_text'>
                    <h1>Get started <br />on your <br />learning journey</h1>
                </div>
                <img src={coursePageBg} alt="courses" />
            </div>
            {courses && courses.length !== 0 && // check if user is enrolled in any course
                <div className='section'>
                    <div className="section_title_wrapper">
                        <h2 className='section_title'>My Enrolled Courses</h2>
                    </div>
                    <div className='section_wrapper'>
                        <Grid className='grid' container spacing={{ xs: 1, sm: 2, md: 1 }} columns={{ xs: 4, sm: 9, md: 16 }}>
                            {courses.map((course) => (
                                <Grid item xs={2} sm={3} md={4} key={course.id}>
                                    <Paper className='course_card' key={course.id} onClick={() => takeCourse(course.id)}>
                                        <div className='image_wrapper'>
                                            <img src={course.image || "/logo512.png"} alt={course.title} />
                                        </div>
                                        <div className='title_wrapper'>
                                            <div  className='title'>{course.title + ` - ${course.progress}%`}</div>
                                        </div>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                </div>
            }

            <div className='section'>
                <div className="section_title_wrapper">
                    <h2 className='section_title'>Courses</h2>
                </div>
                <div className='section_wrapper'>
                    <Grid className='grid' container spacing={{ xs: 1, sm: 3, md: 1 }} columns={{ xs: 4, sm: 9, md: 16 }}>
                        {wordpressCourses.map((course) => (
                            <Grid item xs={2} sm={3} md={4} key={course.id}>
                                <Paper className='course_card' key={course.id} onClick={() => window.location.href = course.url}>
                                    <div className='image_wrapper'>
                                        <img src={course.image || "/logo512.png"} alt={course.title} />
                                    </div>
                                    <div className='title_wrapper'>
                                        <div className='title'>{course.title}</div>
                                    </div>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </div>
        </>
    )
}

export default MyCourses